import { render, staticRenderFns } from "./envirothon.vue?vue&type=template&id=168972cb&scoped=true&"
import script from "./envirothon.vue?vue&type=script&lang=js&"
export * from "./envirothon.vue?vue&type=script&lang=js&"
import style0 from "./envirothon.vue?vue&type=style&index=0&id=168972cb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168972cb",
  null
  
)

export default component.exports